// Çekiliş yapılandırması – tarihleri/ödülleri buradan değiştirin

export const SWEEPSTAKE = {
  title: "Açılışa Özel Çekiliş",
  subtitle: "Her paket satın alan herkes otomatik olarak çekilişe katılır.",
  heroImage: "/galeri/wedding-anasayfa-web.webp",

  // Türkiye saati düşünülerek ISO verin:
  entryStartAt: "2025-09-01T00:00:00+03:00", // Katılım başlangıcı
  entryEndAt:   "2025-09-30T23:59:59+03:00", // Katılım bitişi
  drawAt:       "2025-10-02T20:00:00+03:00", // Çekiliş tarihi (TSİ)

  prizes: [
    { rank: 1, title: "Pro Paket satın alımlarda", note: "1 çifte, 1 adet iphone 17 pro , 1 çifte yarım altın, çeyrek altın x3   " },
    { rank: 2, title: "Standart Paket (6 Ay)", note: "3 kişi" },
    { rank: 3, title: "Baskı Seti Hediye", note: "5 kişi" },
  ],

  // Yasal/operasyonel notlar
  terms: [
    "Çekilişe katılım, kampanya tarihleri arasında gerçekleştirilen her yeni paket satın alımı için otomatik olarak 1 (bir) çekiliş hakkı sağlar.",
    "Aynı kişi birden fazla satın alma yaparsa, her sipariş ayrı bir çekiliş hakkı sayılır.",
    "Çekiliş, bilgisayar ortamında rastgele seçim yöntemiyle yapılacaktır.",
    "Kazananlar, kayıtlı e-posta/telefon üzerinden bilgilendirilecek ve web sitemizde duyurulacaktır.",
    "Ödüller devredilemez, nakde çevrilemez ve stok/koşullara bağlı eşdeğeri ile değiştirilebilir.",
    "Yanlış/eksik iletişim bilgileri nedeniyle ulaşılamayan katılımcılardan dolayı sorumluluk kabul edilmez.",
    "Şirket çalışanları ve birinci derece yakınları kampanyaya katılamaz.",
    "Katılımcılar, kişisel verilerinin çekilişin yürütülmesi ve bilgilendirme amacıyla işlenmesine onay vermiş sayılır.",
    "Kampanya; mücbir sebepler, teknik arızalar veya düzenleyici değişiklikler sebebiyle önceden haber verilmeksizin güncellenebilir/sonlandırılabilir.",
    "Tüm saatler Türkiye saati (TSİ) esas alınır."
  ],
};

export const trDate = (iso: string) =>
  new Date(iso).toLocaleString("tr-TR", {
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit"
  });

export const nowMs = () => Date.now();

export const isActiveWindow = () => {
  const n = nowMs();
  return n >= Date.parse(SWEEPSTAKE.entryStartAt) && n <= Date.parse(SWEEPSTAKE.entryEndAt);
};
export const isUpcomingWindow = () => nowMs() < Date.parse(SWEEPSTAKE.entryStartAt);
export const isEndedWindow = () => nowMs() > Date.parse(SWEEPSTAKE.entryEndAt);
